import Loadable from 'react-loadable';
import Loading from '../Loading';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "RewardsTable" */ '../../components/rewards/RenderRewardsTable'),
  loading: Loading(),
});
